/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { init as initSentry, setUser } from '@sentry/browser';
import { machine } from './machine';
import { ExtraErrorData as ExtraErrorDataIntegration } from '@sentry/integrations';
import { getOriginFromUrl } from '../services/UrlService';

export const enableSentry = true;
export const sentryDsn =
  'https://aea58d6bc039487ba84e6f85961d55cc@sentry.io/1512236';

export function init() {
  if (enableSentry) {
    initSentry({
      dsn: sentryDsn,
      ignoreErrors: ['Non-Error promise rejection captured'],
      environment: getOriginFromUrl(),
      release: `unified-launch-frontend@${process.env.REACT_APP_VERSION}-${process.env.REACT_APP_GIT_SHA}`,
      integrations: [new ExtraErrorDataIntegration()],
    });

    setUser({ id: machine.id });
  }
}
